<template>
  <div id="app">
    <transition name="fade">
      <Loading v-if="isLoading"></Loading>
    </transition>
    <Side v-if="isLoggedIn && isPathWithAuth && !isSystemError"/>
    <div v-if="isSystemError" class="systemErrorWrapper">
      <router-view />
    </div>
    <div v-else-if="isLoggedIn && isPathWithAuth" class="wrapper">
      <div v-if="isNearExpiredPassword" class="password-alert">
        <i class="aikon aikon-attention password-alert-icon"></i>
        <div class="password-alert-content">
          <p class="password-alert-text">アカウントパスワードの有効期限：{{ expiredDate }}まで</p>
          <router-link class="btn password-alert-btn" :to="{ name: 'PasswordReset' }">パスワードを更新する</router-link>
        </div>
      </div>
      <router-view />
    </div>
    <div v-else-if="!isLoggedIn || !isPathWithAuth" class="login">
      <router-view />
    </div>
    <Alert />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Loading from '@/components/Loading';
import Alert from '@/components/Alert.vue';
import Side from '@/components/Side.vue';
import { formatJapaneseDate } from '@/helpers/formatData';

const store = useStore();
const route = useRoute();

const isPathWithAuth = ref(null);

const passwordExpiresAt = computed(() => store.getters['auth/passwordExpiresAt']);
const isLoading = computed(() => store.getters['common/isLoading']);
const isLoggedIn = computed(() => store.getters['auth/token']);
const isNearExpiredPassword = computed(() => store.getters['auth/isNearExpiredPassword']);

const isSystemError = computed(() => route.name === '500');
const expiredDate = computed(() => formatJapaneseDate(passwordExpiresAt.value));

const checkPathWithAuth = () => {
  isPathWithAuth.value = !['/login', '/password/default', '/password/reset', '/password/code'].includes(window.location.pathname);
};

watch(() => route.path, () => {
  checkPathWithAuth();
});

onMounted(() => {
  checkPathWithAuth();
});
</script>
